// @flow
//
import React, { Component } from 'react'
import {
  Redirect,
  Route,
  Switch
} from 'react-router'
import {injectGlobal} from 'styled-components'
import {styles} from 'tutellus-ui'

import {
  AboutUs,
  AffiliateApi,
  Careers,
  Certificates,
  Channels,
  Gifts,
  Home,
  HowItWork,
  NotFound,
  Subscription,
  Teachers
} from './pages'

export default class extends Component/*:: <{}> */ {
  componentDidMount () {
    injectGlobal`${styles.global}`
  }
  render () {
    return (
      <Switch>
        <Route exact path='/' component={Home} />
        <Route exact path='/informacion/nosotros' component={AboutUs} />
        <Route exact path='/informacion/afiliados' component={AffiliateApi} />
        <Route exact path='/carreras/' component={Careers} />
        <Route exact path='/informacion/certificados' component={Certificates} />
        <Route exact path='/canales/' component={Channels} />
        <Route exact path='/informacion/regala' component={Gifts} />
        <Route exact path='/informacion/como-funciona' component={HowItWork} />
        <Route exact path='/informacion/unlimited' component={Subscription} />
        <Route exact path='/informacion/profesores' component={Teachers} />
        <Route exact path='/404' component={NotFound} />
        <Redirect to='/404' />
      </Switch>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js